module.exports = __webpack_public_path__ + "img/avatar5.a4558631.png";